/**
 * 调试工具
 * 用于诊断权限检查问题
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * 权限检查调试器
 */
var PermissionDebugger = /** @class */ (function () {
    function PermissionDebugger() {
    }
    /**
     * 记录权限检查过程
     */
    PermissionDebugger.log = function (user, requiredPermissions, result, steps) {
        var debugInfo = {
            timestamp: new Date().toISOString(),
            user: {
                id: user === null || user === void 0 ? void 0 : user.id,
                account: user === null || user === void 0 ? void 0 : user.account,
                permissions: user === null || user === void 0 ? void 0 : user.permissions,
                isSuperAdmin: user === null || user === void 0 ? void 0 : user.isSuperAdmin,
                is_super_admin: user === null || user === void 0 ? void 0 : user.is_super_admin
            },
            requiredPermissions: requiredPermissions,
            result: result,
            steps: steps
        };
        this.logs.push(debugInfo);
        // 在开发环境下输出到控制台
        if (process.env.NODE_ENV === 'development') {
            console.group("[PermissionDebugger] ".concat(result ? '✅' : '❌', " \u6743\u9650\u68C0\u67E5"));
            console.log('用户信息:', debugInfo.user);
            console.log('所需权限:', debugInfo.requiredPermissions);
            console.log('检查步骤:', debugInfo.steps);
            console.log('结果:', result);
            console.groupEnd();
        }
    };
    /**
     * 获取所有日志
     */
    PermissionDebugger.getLogs = function () {
        return __spreadArray([], this.logs, true);
    };
    /**
     * 清除日志
     */
    PermissionDebugger.clearLogs = function () {
        this.logs = [];
    };
    /**
     * 获取最新的日志
     */
    PermissionDebugger.getLatestLog = function () {
        return this.logs.length > 0 ? this.logs[this.logs.length - 1] : null;
    };
    /**
     * 输出调试信息到页面
     */
    PermissionDebugger.renderDebugInfo = function () {
        if (typeof window === 'undefined')
            return null;
        var latestLog = this.getLatestLog();
        if (!latestLog)
            return null;
        return {
            user: latestLog.user,
            requiredPermissions: latestLog.requiredPermissions,
            result: latestLog.result,
            steps: latestLog.steps,
            timestamp: latestLog.timestamp
        };
    };
    PermissionDebugger.logs = [];
    return PermissionDebugger;
}());
export { PermissionDebugger };
/**
 * 简化的权限检查函数（带调试）
 */
export function debugCheckPermissions(user, requiredPermissions) {
    var steps = [];
    try {
        steps.push('开始权限检查');
        if (!user) {
            steps.push('❌ 用户不存在');
            PermissionDebugger.log(user, requiredPermissions, false, steps);
            return false;
        }
        steps.push("\u2705 \u7528\u6237\u5B58\u5728: ".concat(user.account || user.admin_name || 'unknown'));
        if (!requiredPermissions || requiredPermissions.length === 0) {
            steps.push('✅ 无需权限验证');
            PermissionDebugger.log(user, requiredPermissions, true, steps);
            return true;
        }
        var userPermissions_1 = user.permissions || [];
        steps.push("\uD83D\uDCCB \u7528\u6237\u6743\u9650\u5217\u8868: [".concat(userPermissions_1.join(', '), "]"));
        steps.push("\uD83D\uDCCB \u6240\u9700\u6743\u9650\u5217\u8868: [".concat(requiredPermissions.join(', '), "]"));
        // 1. 检查全局通配符权限
        if (userPermissions_1.includes('*')) {
            steps.push('✅ 用户拥有全局通配符权限');
            PermissionDebugger.log(user, requiredPermissions, true, steps);
            return true;
        }
        // 2. 检查具体权限匹配
        var hasPermission = requiredPermissions.some(function (permission) {
            // 精确匹配
            if (userPermissions_1.includes(permission)) {
                steps.push("\u2705 \u7CBE\u786E\u5339\u914D\u6743\u9650: ".concat(permission));
                return true;
            }
            // 服务通配符匹配
            var servicePrefix = permission.split(':')[0];
            var serviceWildcard = "".concat(servicePrefix, ":*");
            if (userPermissions_1.includes(serviceWildcard)) {
                steps.push("\u2705 \u670D\u52A1\u901A\u914D\u7B26\u5339\u914D: ".concat(serviceWildcard, " \u5339\u914D ").concat(permission));
                return true;
            }
            // 功能通配符匹配
            var parts = permission.split(':');
            if (parts.length >= 3) {
                var functionPrefix = parts.slice(0, -1).join(':');
                var functionWildcard = "".concat(functionPrefix, ":*");
                if (userPermissions_1.includes(functionWildcard)) {
                    steps.push("\u2705 \u529F\u80FD\u901A\u914D\u7B26\u5339\u914D: ".concat(functionWildcard, " \u5339\u914D ").concat(permission));
                    return true;
                }
            }
            steps.push("\u274C \u6743\u9650\u4E0D\u5339\u914D: ".concat(permission));
            return false;
        });
        steps.push("\uD83C\uDFAF \u6700\u7EC8\u7ED3\u679C: ".concat(hasPermission ? '✅ 通过' : '❌ 拒绝'));
        PermissionDebugger.log(user, requiredPermissions, hasPermission, steps);
        return hasPermission;
    }
    catch (error) {
        var errorMessage = error instanceof Error ? error.message : String(error);
        steps.push("\u274C \u6743\u9650\u68C0\u67E5\u51FA\u9519: ".concat(errorMessage));
        PermissionDebugger.log(user, requiredPermissions, false, steps);
        return false;
    }
}
/**
 * 在浏览器控制台中暴露调试工具
 */
export function exposeDebugTools() {
    if (typeof window !== 'undefined') {
        window.PermissionDebugger = PermissionDebugger;
        window.debugCheckPermissions = debugCheckPermissions;
        console.log('🔧 权限调试工具已暴露到 window.PermissionDebugger 和 window.debugCheckPermissions');
    }
}
